(function () {
  'use strict';
  angular.module('vcconsult')
    .component('consultsearch', {
      restrict: 'E',
      bindings: {
        consult: '<',
        consultref: '<',
        parentsave: '&?',
        editinplace: '@?',
        ti: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showconsult($item, $model, $label)"
                   uib-typeahead="consult as consult.text for consult in vm.getConsults($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-spin fa-spinner"></i>
        <div ng-show="noResults">
          <i class="fa fa-warning"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addConsult()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addConsult()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <consulteditor consult="vm.consult"></consulteditor>
        </div>
        
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Consult', 'ConsultHelper',
        function ($log, Consult, ConsultHelper) {
          let vm = this;
          vm.save = save;
          vm.showconsult = showconsult;

          vm.getConsults = getConsults;
          // vm.addConsult = ConsultHelper.addConsult;
          vm.addConsult = addConsult;
          vm.editConsult = ConsultHelper.editConsult;

          vm.$onInit = function () {
            vm.newconsult = {};

            if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
              vm.editinplace = true;
            }

            $log.debug('debug - editinplace', vm.editinplace);


            if (angular.isUndefined(vm.ti)) {
              vm.ti = 0;
              vm.tabi = 0;
            }
            if (angular.isString(vm.ti)) {
              vm.tabi = parseInt(vm.ti, 10);
            }
            else {
              vm.tabi = 0;
            }
            vm.lastconsult = angular.copy(vm.consultresult);
            vm.lastconsultref = angular.copy(vm.consultref);
          };

          function addConsult() {
            $log.debug('debug - consultsearch addConsult called');
            ConsultHelper.addConsult(function (consult) {
              $log.debug('debug: handle newly create consult');
              vm.consult = {};
              vm.consult.name = consult.name;
              vm.consult.short = consult.short;
              vm.consult._id = consult._id;
              vm.consultref = consult._id;
              vm.asyncSelected = consult.short;
              vm.parentsave({consult: vm.consult, consultref: vm.consultref});
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }


          // typeahead consult search backend query
          function getConsults(val) {
            // return Consultahead.$search({query: val}).$asPromise().then(function (response) {
            return Consult.$searchahead({query: val}).$asPromise().then(function (response) {
              return response.map(function (consult) {
                consult.text = consult.short;
                delete vm.error;
                return consult;
              });
            });
          }

          // typeahead consult search action
          function showconsult($item, $model, $label) {
            /* eslint "no-unused-vars": [0, {"args": "none"}] */
            vm.consult = $model;
            vm.consultref = $model._id;
            delete vm.asyncSelected;
            vm.editinplace = true;
            $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
            if (vm.editinplace === true) {
              vm.consult = $model;
              vm.consultref = $model._id;
              $log.debug('debug - consultsearch editinplace');
            }
            else {
              vm.consult = {};
              vm.consult.name = $model.name;
              vm.consult.short = $model.short;
              vm.consult._id = $model._id;
              vm.consultref = $model._id;
              vm.parentsave({consult: vm.consult, consultref: vm.consultref});
              $log.debug('debug - consultsearch do not  editinplace', vm.parentsave);
            }
          }

          function save() {
            if (!angular.equals(vm.consult, vm.lastconsult) || !angular.equals(vm.consultref, vm.lastconsultref)) {
              vm.lastconsult = angular.copy(vm.consult);
              vm.lastconsultref = angular.copy(vm.consultref);
              vm.parentsave({consult: vm.consult, consultref: vm.consultref});
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
